import { computed, Ref } from "vue";
import { useCustomMutation } from "@/api/graphqlClient/useCustomMutation";
import {
  SendOtpUsingEmail,
  SendOtpUsingEmail_sendOtpUsingEmail_GenericSuccess,
} from "@/api/email/__generated__/SendOtpUsingEmail";
import { sendOtpUsingEmailGql } from "@/api/email/sendOtpUsingEmail";
import {
  SendOtpUsingEmailNonAuthenticated,
  SendOtpUsingEmailNonAuthenticated_sendOtpUsingEmailNonAuthenticated_GenericSuccess,
} from "@/api/email/__generated__/SendOtpUsingEmailNonAuthenticated";
import { sendOtpUsingEmailNonAuthenticatedGql } from "@/api/email/sendOtpUsingEmailNonAuthenticated";
import { parseGqlResponse } from "@/shared/utils/graphql/responseParser";
import { makeToast } from "@/shared/utils/toast";
import { useI18n } from "vue-i18n";

export function useOtpSendViaEmail(): {
  sendOtpViaEmailMutation?;
  sendOtpViaEmailLoading: Ref<boolean>;
  sendOtpViaEmail: () => void;
  sendOtpViaEmailNonAuthMutation?;
  sendOtpViaEmailNonAuthLoading: Ref<boolean>;
  sendOtpViaEmailNonAuth: ({ username, password }) => void;
} {
  const t = useI18n().t;

  // Send OTP via Email Authenticated
  const sendOtpViaEmailMutation =
    useCustomMutation<SendOtpUsingEmail>(sendOtpUsingEmailGql);

  const sendOtpViaEmail = async () => {
    const sendOtpViaEmailResponse = await sendOtpViaEmailMutation.mutate();

    const parsedGqlResponse =
      parseGqlResponse<SendOtpUsingEmail_sendOtpUsingEmail_GenericSuccess>(
        "GenericSuccess",
        sendOtpViaEmailResponse
      );

    if (parsedGqlResponse.data?.success) {
      makeToast("success", t("Success"), t("OTP is sent via Email"));
    }
  };
  // END of Send OTP via Email Authenticated

  // Send OTP via Email Non Authenticated
  const sendOtpViaEmailNonAuthMutation =
    useCustomMutation<SendOtpUsingEmailNonAuthenticated>(
      sendOtpUsingEmailNonAuthenticatedGql
    );

  const sendOtpViaEmailNonAuth = async ({ username, password }) => {
    const sendOtpViaEmailNonAuthResponse =
      await sendOtpViaEmailNonAuthMutation.mutate({
        input: {
          password,
          username,
        },
      });

    const parsedGqlResponse =
      parseGqlResponse<SendOtpUsingEmailNonAuthenticated_sendOtpUsingEmailNonAuthenticated_GenericSuccess>(
        "GenericSuccess",
        sendOtpViaEmailNonAuthResponse
      );

    if (parsedGqlResponse.data?.success) {
      makeToast("success", t("Success"), t("OTP is sent via Email"));
    }
  };
  // END of Send OTP via Email Non Authenticated

  return {
    sendOtpViaEmailMutation,
    sendOtpViaEmailLoading: computed(
      () => sendOtpViaEmailMutation.loading.value
    ),
    sendOtpViaEmail,
    sendOtpViaEmailNonAuthMutation,
    sendOtpViaEmailNonAuthLoading: computed(
      () => sendOtpViaEmailNonAuthMutation.loading.value
    ),
    sendOtpViaEmailNonAuth,
  };
}
